// Single source of truth for public contact details.
export const CONTACT = {
  email: "justjjax@gmail.com",
  whatsapp: "447492695786", // business WhatsApp, international format (no + or spaces)
  address: "38 The Strand, Bude, EX23 8RA",
  instagram: "https://www.instagram.com/justjjax/",
  bookingUrl: "https://tinyurl.com/2nxodcgu",
  businessName: "Justjjax",
};

export const whatsappLink = () =>
  CONTACT.whatsapp ? `https://wa.me/${CONTACT.whatsapp}` : null;
